import { InjectionToken } from '@angular/core';

export const AUTH0_DOMAIN = new InjectionToken<string>('AUTH0_DOMAIN');
export const CONNECT_API_BASE_URL = new InjectionToken<string>(
  'CONNECT_API_BASE_URL'
);
export const CONNECT_ADMIN_BASE_URL = new InjectionToken<string>(
  'CONNECT_ADMIN_BASE_URL'
);
export const LOCAL_STORAGE = new InjectionToken<Storage>('LOCAL_STORAGE', {
  providedIn: 'root',
  factory: (): Storage => localStorage,
});
export const WINDOW = new InjectionToken<Window>('WINDOW', {
  providedIn: 'root',
  factory: (): Window => window,
});
